import { useRef } from "react";
import { toast } from "sonner";
import { api, BACKEND_URL } from "@/lib/api";
import { useContent } from "@/context/ContentContext";

export const E = ({ k, f = "" }) => {
  const { t, isAdminEditing, drafts, setDraft, version } = useContent();
  const value = drafts[k] !== undefined ? drafts[k] : t(k, f);
  if (!isAdminEditing) return <span data-content-key={k}>{value}</span>;
  return (
    <span
      key={`${version}:${k}`}
      contentEditable
      suppressContentEditableWarning
      spellCheck={false}
      data-testid={`editable-${k}`}
      className={`editable-text ${drafts[k] !== undefined ? "editable-dirty" : ""}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.currentTarget.blur(); } }}
      onBlur={(e) => setDraft(k, e.currentTarget.innerText, f)}
    >
      {value}
    </span>
  );
};

export const EImg = ({ k, f = "", alt = "", className = "", style, wrapClassName = "", testId }) => {
  const { t, isAdminEditing, drafts, setDraft } = useContent();
  const inputRef = useRef(null);
  const raw = drafts[k] !== undefined ? drafts[k] : t(k, f);
  const src = raw && raw.startsWith("/api") ? `${BACKEND_URL}${raw}` : raw;
  if (!isAdminEditing) return <img src={src} alt={alt} className={className} style={style} data-testid={testId} />;

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("image", file);
    try {
      const { data } = await api.post("/admin/content/upload-image", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setDraft(k, data.url, f);
      toast.success("Photo updated — press Publish to make it live.");
    } catch (err) {
      toast.error("Upload failed. Please use an image under 5MB.");
    }
    e.target.value = "";
  };

  return (
    <span
      className={`editable-img-wrap ${wrapClassName}`}
      data-testid={`editable-img-${k}`}
      onClick={(ev) => { ev.preventDefault(); ev.stopPropagation(); inputRef.current?.click(); }}
    >
      <img
        src={src}
        alt={alt}
        className={`${className} ${drafts[k] !== undefined ? "editable-img-dirty" : ""}`}
        style={style}
      />
      <span className="editable-img-overlay">Change photo</span>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        data-testid={`editable-img-input-${k}`}
        onChange={pick}
        onClick={(ev) => ev.stopPropagation()}
      />
    </span>
  );
};
